/**
 * Event codes syntax:
 *  First character = initial of object
 *  Second character = initial of action
 * e.g.) rd
 *  r = report
 *  d = download
 * Rationale: to make it easier to group events by the first initial 
 *
 * ¯\_(ツ)_/¯
 */
export const EVENT = {
  VisitSite : 'sv',
  CreateOrganization : 'oc',
  UpdateOrganization : 'ou',
  CreateReport : 'rc',
  UpdateReport : 'ru',
  EmailReport : 're',
  DownloadReport : 'rd',
  VisitReport : 'rv',
  GenerateSummary: 'sg',
  GenerateReportCard: 'rcg',
  UIShowTopThemes : 'ui-st',
  UIGenerateMaterials : 'ui-gm',
  UIReturnToDashboard : 'ui-rd',
  UIStartOver : 'ui-so',
};

// TODO Update to Record<RaceDataType, {ep_age17: '', ep_age65: {male: '', female: ''}}>
export const PHOTO_SOURCES = {
  race_asian_pi: {
    child: 'api-c.png',
    adult: {
      male: 'api-a-m.png',
      female: 'api-a-f.png',
    },
    olderAdult: {
      male: 'api-oa-m.png',
      female: 'api-oa-f.png',
    },
  },
  race_black: {
    child: 'b-c.png',
    adult: {
      male: 'b-a-m.png',
      female: 'b-a-f.png',
    },
    olderAdult: {
      male: 'b-oa-m.png',
      female: 'b-oa-f.png',
    },
  },
  ethnicity_hispanic: {
    child: 'h-c.png',
    adult: {
      male: 'h-a-m.png',
      female: 'h-a-f.png',
    },
    olderAdult: {
      male: 'h-oa-m.png',
      female: 'h-oa-f.png',
    },
  },
  race_native_amer: {
    child: 'na-c.png',
    adult: {
      male: 'na-a-m.png',
      female: 'na-a-f.png',
    },
    olderAdult: {
      male: 'na-oa-m.png',
      female: 'na-oa-f.png',
    },
  },
  race_other: {
    child: 'o-c.png',
    adult: {
      male: 'o-a-m.png',
      female: 'o-a-f.png',
    },
    olderAdult: {
      male: 'o-oa-m.png',
      female: 'o-oa-f.png',
    },
  },
  race_white: {
    child: 'w-c.png',
    adult: {
      male: 'w-a-m.png',
      female: 'w-a-f.png',
    },
    olderAdult: {
      male: 'w-oa-m.png',
      female: 'w-oa-f.png',
    },
  },
};

// TODO Update to Record<RaceDataType, {ep_age17: '', ep_age65: {male: '', female: ''}}>
export const THEME_PHOTO_REQUIREMENTS = {
  3: {
    age: 'child',
  },
  26: {
    sex: 'female',
  },
  24: {
    sex: 'female',
    age: 'olderAdult',
  },
  30: {
    sex: 'female',
    age: 'olderAdult',
  },
  28: {
    sex: 'male'
  },
  29: {
    sex: 'male',
    age: 'olderAdult',
  },
  33: {
    age: 'olderAdult',
  },
  32: {
    age: 'child',
  }
};
